import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/animations';

const headers = ['Period', 'WGH Fee', 'Total/Month', 'Blended $/hr'];

export function PricingTable({ heading, intro, rows, testId }) {
    return (
        <motion.div {...fadeUp} className="mb-10">
            <h3 className="font-montserrat font-bold text-xl text-navy-900 mb-2">{heading}</h3>
            {intro && <p className="text-[#6B7280] text-sm mb-4">{intro}</p>}
            <div className="bg-white border border-gray-100 rounded-sm overflow-x-auto shadow-sm" data-testid={testId}>
                <table className="w-full min-w-[560px]">
                    <thead>
                        <tr className="bg-navy-900">
                            {headers.map((h) => (
                                <th key={h} className="px-6 py-4 text-white text-xs font-bold uppercase tracking-wider text-left font-montserrat">{h}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, i) => (
                            <tr key={row[0]} className={i % 2 === 0 ? 'bg-white' : 'bg-[#F8F9FA]'}>
                                {row.map((cell, j) => (
                                    <td key={cell} className={j === 0 ? 'px-6 py-4 text-[#6B7280] text-sm font-semibold' : 'px-6 py-4 text-navy-900 font-bold text-sm'}>
                                        {cell}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </motion.div>
    );
}
